import { useMemo } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';

export const useActiveLocationPath = () => {
  const location = useLocation();
  return useMemo(() => location.pathname + (location.search || ''), [location]);
};
